import React from 'react';
import ResponsiveInline from 'components/commercetools-ui/organisms/content/cms-components/section-with-cards/responsive-in-line';
import StackedOnMobile from 'components/commercetools-ui/organisms/content/cms-components/section-with-cards/stacked-on-mobile';
import CarouselFollowUsStyle from 'components/commercetools-ui/organisms/content/cms-components/section-with-cards/carousel-follow-us-style';

const SectionWithCards = (props: any) => {
    const { content } = props;
    //console.log('SectionWithCards', content);

    const ComponentRegistry: { [key: string]: React.ElementType } = {
        ResponsiveInline: ResponsiveInline,
        StackedOnMobile: StackedOnMobile,
        CarouselFollowUsStyle: CarouselFollowUsStyle,
    };
    
    const Component = ComponentRegistry[content.component_type];    
    if(Component)
        return <Component content={content} />;
    else
        return null;
  
};

export default SectionWithCards;

